import React from "react";
import StaticContentPage from "./StaticContentPage";
import { shippingPolicyText } from "../data/staticPagesContent";

const ShippingPolicy = () => {
  return (
    <StaticContentPage
      title="Shipping & Returns"
      seoTitle="Shipping Policy | Delivery, Returns & Order Support | Eveness"
      seoDescription="Read Eveness shipping policy, delivery information, order processing details, returns guidance, and support information for your fashion purchases."
      canonicalPath="/policies/shipping-policy"
    >
      {shippingPolicyText}
    </StaticContentPage>
  );
};

export default ShippingPolicy;